module.exports = __webpack_public_path__ + "img/plus.f0b13127.svg";